module.exports = __webpack_public_path__ + "static/gtm-567442a92f1ee15381be3b98ab4a2444.png";